import { t } from "ttag";

import type { GenericErrorResponse } from "metabase/utils/errors";

export const getUpdateApiErrorMessage = (
  error: GenericErrorResponse | unknown,
): string => {
  const maybeError = error as GenericErrorResponse;

  if (typeof maybeError.data === "string") {
    return maybeError.data;
  }

  if (
    Array.isArray(maybeError.data?.errors) &&
    maybeError.data.errors[0] &&
    ("message" in maybeError.data.errors[0] ||
      "error" in maybeError.data.errors[0])
  ) {
    return maybeError.data.errors[0].message ?? maybeError.data.errors[0].error;
  }

  if (
    Array.isArray(maybeError.errors) &&
    ("message" in maybeError.errors[0] || "error" in maybeError.errors[0])
  ) {
    return maybeError.errors[0].message ?? maybeError.errors[0].error;
  }

  if (typeof maybeError.data?.message === "string") {
    return maybeError.data.message;
  }

  return t`Unknown error`;
};

export function getUpdateApiErrorType(error: unknown): string {
  const firstError = getFirstBulkError(error);
  return typeof firstError?.type === "string" ? firstError.type : "";
}

export function getUpdateApiTableId(error: unknown): number | undefined {
  const firstError = getFirstBulkError(error);
  return typeof firstError?.["table-id"] === "number"
    ? firstError["table-id"]
    : undefined;
}

// execute-bulk's error response shape is `{ errors: [{ type, "table-id", ... }], results: [] }`,
// nested under RTK Query's own `{ status, data }` wrapper -- not the single `data.data` shape
// this used to look for, which never matched anything a real bulk-edit error actually returns.
function getFirstBulkError(
  error: unknown,
): Record<string, unknown> | undefined {
  if (
    isRecord(error) &&
    isRecord(error.data) &&
    Array.isArray(error.data.errors) &&
    isRecord(error.data.errors[0])
  ) {
    return error.data.errors[0];
  }

  return undefined;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
